import { MarkerClusterer } from "@googlemaps/markerclusterer";

const mapStyles = {
  "snazzy-earth": [
    {
      featureType: "administrative.country",
      elementType: "geometry.stroke",
      stylers: [{ color: "#C3C2B8" }, { weight: 1 }],
    },
    {
      featureType: "administrative.country",
      elementType: "labels.text.fill",
      stylers: [{ color: "#8E8B79" }],
    },
    {
      featureType: "administrative.province",
      elementType: "geometry.stroke",
      stylers: [{ color: "#8E8B79" }, { weight: 0.5 }],
    },
    {
      featureType: "administrative.province",
      elementType: "labels.text.fill",
      stylers: [{ color: "#8E8B79" }],
    },
    {
      featureType: "administrative.locality",
      elementType: "labels.text.fill",
      stylers: [{ color: "#777463" }],
    },
    {
      featureType: "landscape",
      elementType: "all",
      stylers: [
        { hue: "#FFBB00" },
        { saturation: 43.4 },
        { lightness: 37.6 },
        { gamma: 1 },
      ],
    },
    {
      featureType: "landscape.man_made",
      elementType: "all",
      stylers: [{ color: "#f8f8f5" }],
    },
    {
      featureType: "landscape.natural",
      elementType: "geometry.fill",
      stylers: [{ color: "#f8f8f5" }],
    },
    {
      featureType: "landscape.natural.landcover",
      elementType: "geometry.fill",
      stylers: [{ color: "#f8f8f5" /*"#e4eacb"*/ }],
    },
    {
      featureType: "poi",
      elementType: "all",
      stylers: [
        { hue: "#00ff6a" },
        { saturation: -1.0989 },
        { lightness: 11.2 },
        { gamma: 1 },
        { visibility: "off" },
      ],
    },
    {
      featureType: "road.highway",
      elementType: "all",
      stylers: [
        { hue: "#ffc200" },
        { saturation: -61.8 },
        { lightness: 45.6 },
        { gamma: 1 },
      ],
    },
    {
      featureType: "road.highway.controlled_access",
      elementType: "labels.icon",
      stylers: [
        { hue: "#ffdc00" },
        { visibility: "on" },
        { gamma: "0.40" },
        { lightness: "32" },
        { saturation: "-53" },
      ],
    },
    {
      featureType: "road.arterial",
      elementType: "all",
      stylers: [
        { hue: "#FF0300" },
        { saturation: -100 },
        { lightness: 51.2 },
        { gamma: 1 },
      ],
    },
    {
      featureType: "road.arterial",
      elementType: "geometry.fill",
      stylers: [{ color: "#d5d2c9" }],
    },
    {
      featureType: "road.arterial",
      elementType: "labels.text.fill",
      stylers: [{ color: "#afa994" }],
    },
    {
      featureType: "road.local",
      elementType: "all",
      stylers: [
        { hue: "#FF0300" },
        { saturation: -100 },
        { lightness: 52 },
        { gamma: 1 },
      ],
    },
    {
      featureType: "road.local",
      elementType: "geometry.fill",
      stylers: [{ color: "#d5d2c9" }],
    },
    {
      featureType: "road.local",
      elementType: "labels.text.fill",
      stylers: [{ color: "#afa994" }],
    },
    {
      featureType: "transit",
      elementType: "geometry.fill",
      stylers: [{ color: "#d5d2c9" }],
    },
    {
      featureType: "transit.station.rail",
      elementType: "labels.icon",
      stylers: [{ visibility: "off" }],
    },
    {
      featureType: "water",
      elementType: "all",
      stylers: [
        { hue: "#0078ff" },
        { saturation: -13.2 },
        { lightness: 2.4 },
        { gamma: 1 },
      ],
    },
    {
      featureType: "water",
      elementType: "geometry.fill",
      stylers: [{ color: "#94aaba" }],
    },
  ],
};

function generateClusterIcon(count) {
  return (
    "data:image/svg+xml;charset=UTF-8," +
    encodeURIComponent(`
      <svg width="33" height="33" viewBox="0 0 33 33" xmlns="http://www.w3.org/2000/svg" shape-rendering="geometricPrecision">
        <circle cx="16.5" cy="16.5" r="14" stroke="#925F52" fill="none"/>
        <circle cx="16.5" cy="16.5" r="12.5" fill="#925F52"/>
        <circle cx="16.5" cy="16.5" r="16" stroke="#925F52" fill="none"/>
        <text
          x="16.5"
          y="18"
          text-anchor="middle"
          dominant-baseline="middle"
          font-size="13"
          fill="white"
          font-family="Arial, sans-serif"
          font-weight="bold"
        >${count}</text>
      </svg>
    `)
  );
}

export function initGoogleMaps() {
  const mapElements = document.querySelectorAll(".custom-map");

  mapElements.forEach((el) => {
    const zoom = parseInt(el.dataset.zoom) || 5;
    const style = mapStyles["snazzy-earth"];
    const interactive = el.dataset.interactive !== "false"; // default true
    const scroll = el.dataset.scroll !== "false"; // default true
    const gestureHandling = interactive ? "auto" : "none";
    const showUI = interactive;
    const maxZoom = parseInt(el.dataset.maxzoom) || 21;
    const minZoom = parseInt(el.dataset.minzoom) || 5;

    let mapCenter = { lat: 39.8283, lng: -98.5795 }; // Default to US center

    const map = new google.maps.Map(el, {
      center: mapCenter,
      zoom,
      maxZoom: maxZoom,
      minZoom: minZoom,
      styles: style,
      gestureHandling,
      disableDefaultUI: !showUI,
      zoomControl: interactive,
      scrollwheel: scroll,
      draggable: interactive,
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: false,
    });

    // MULTI-PIN MODE
    if (el.dataset.pins) {
      let pins;
      try {
        pins = JSON.parse(el.dataset.pins);
      } catch (e) {
        console.error("Invalid data-pins JSON:", e);
        return;
      }

      const markers = [];
      const bounds = new google.maps.LatLngBounds();

      pins.forEach((pin) => {
        const position = { lat: parseFloat(pin.lat), lng: parseFloat(pin.lng) };
        bounds.extend(position);

        const defaultIcon = el.dataset.pin;

        const marker = new google.maps.Marker({
          position,
          title: pin.name || "", // 👈 native tooltip on hover
          icon:
            pin.icon || defaultIcon
              ? {
                  url: pin.icon || defaultIcon,
                  scaledSize: new google.maps.Size(32, 32),
                }
              : undefined,
          animation: google.maps.Animation.DROP,
          map, // add this line if clustering is disabled
        });

        // 👇 Add this block to handle URL click
        if (pin.url) {
          marker.addListener("click", () => {
            window.location.href = pin.url;
          });
        }

        markers.push(marker);
      });

      const clusterEnabled = el.dataset.cluster === "true";

      if (clusterEnabled) {
        new MarkerClusterer({
          markers,
          map,
          renderer: {
            render({ count, position }) {
              return new google.maps.Marker({
                position,
                icon: {
                  url: generateClusterIcon(count),
                  scaledSize: new google.maps.Size(33, 33),
                },
                zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
                animation: google.maps.Animation.DROP,
              });
            },
          },
        });
      } else {
        markers.forEach((m) => m.setMap(map));
      }

      map.fitBounds(bounds);
      if (zoom) map.setZoom(zoom);
    } else if (el.dataset.lat && el.dataset.lng) {
      // SINGLE PIN MODE
      const lat = parseFloat(el.dataset.lat);
      const lng = parseFloat(el.dataset.lng);
      const pin = el.dataset.pin || null;
      map.setCenter({ lat, lng });

      new google.maps.Marker({
        position: { lat, lng },
        map,
        icon: pin
          ? {
              url: pin,
              scaledSize: new google.maps.Size(32, 32),
            }
          : undefined,
        animation: google.maps.Animation.DROP,
      });
    }
  });
}

document.addEventListener("DOMContentLoaded", () => {
  const hideBtn = document.getElementById("hide-map-btn");
  const showBtn = document.getElementById("show-map-btn");
  const body = document.body;

  function handleMapVisibility() {
    const windowWidth = window.innerWidth;
    const breakpoint = 1310;

    if (windowWidth < breakpoint) {
      // Always hide map below 1310px
      body.classList.add("map-hidden");
      if (hideBtn) hideBtn.style.display = "none";
      if (showBtn) showBtn.style.display = "inline-block";
    } else {
      // Above 1310px, restore previous state or show map by default
      if (!body.classList.contains("map-hidden")) {
        if (hideBtn) hideBtn.style.display = "inline-block";
        if (showBtn) showBtn.style.display = "none";
      }
    }
  }

  // Run on page load
  handleMapVisibility();

  // Run on window resize
  window.addEventListener("resize", handleMapVisibility);

  if (hideBtn && showBtn) {
    hideBtn.addEventListener("click", () => {
      body.classList.add("map-hidden");
      hideBtn.style.display = "none";
      showBtn.style.display = "inline-block";
    });

    showBtn.addEventListener("click", () => {
      // Only allow showing map if screen is wide enough
      if (window.innerWidth >= 1310) {
        body.classList.remove("map-hidden");
        showBtn.style.display = "none";
        hideBtn.style.display = "inline-block";
      }
    });
  }
});

function setMapWidth() {
  const mapContainer = document.querySelector(".cardmap-map");
  const mapInner = document.querySelector(".cardmap-inner");

  if (mapContainer && mapInner) {
    const mapRect = mapContainer.getBoundingClientRect();
    const distanceFromLeft = mapRect.left;
    const widthToViewportEdge = window.innerWidth - distanceFromLeft;

    mapInner.style.width = `${widthToViewportEdge}px`;
  }
}

// Run on load and resize
document.addEventListener("DOMContentLoaded", setMapWidth);
window.addEventListener("resize", setMapWidth);
